import { actions } from '../../../state/auth';

import Nav from '../../views/Nav';
import { connect } from 'react-redux';

const mapStateToProps = (state, ownProps) => ({
  authenticated: state.shift.auth.authenticated,
  username: state.shift.auth.username,
  status: state.shift.status,
  role: state.shift.auth.role,
});

const mapDispatchToProps = dispatch => ({
  logout: () => {
    localStorage.clear();
    sessionStorage.clear();
    dispatch(actions.logout());
  },

  resetPopError: ()=>{
    dispatch(actions.resetPopError())
  },
});

const NavComponent = connect(
  mapStateToProps,
  mapDispatchToProps
)(Nav);

export default NavComponent;



// WEBPACK FOOTER //
// ./src/components/container/Nav/index.js